'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDefaultChatHeadingConfig = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _immutable = require('immutable');

var _UsersAndTeamsChatHeadingConfig = require('../records/UsersAndTeamsChatHeadingConfig');

var _UsersAndTeamsChatHeadingConfig2 = _interopRequireDefault(_UsersAndTeamsChatHeadingConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildDefaultChatHeadingConfig = exports.buildDefaultChatHeadingConfig = function buildDefaultChatHeadingConfig(currentUser) {
  if (currentUser) {
    return new _UsersAndTeamsChatHeadingConfig2.default({
      userIds: (0, _immutable.List)([(0, _get2.default)('user_id', currentUser)])
    });
  }

  return new _UsersAndTeamsChatHeadingConfig2.default();
};